import React, { useState } from 'react';
import { RefreshCw } from 'lucide-react';
import { cstTime } from '../lib/time';

export default function RefreshButton({ onRefresh, label = 'REFRESH', lastUpdated, testId = 'refresh-btn' }) {
  const [busy, setBusy] = useState(false);
  const go = async () => {
    if (busy) return;
    setBusy(true);
    try { await onRefresh(); } finally { setBusy(false); }
  };
  return (
    <button
      data-testid={testId}
      onClick={go}
      disabled={busy}
      title={lastUpdated ? `last refreshed ${cstTime(lastUpdated)}` : 'refresh'}
      className="flex items-center gap-2 text-[10px] font-display tracking-[0.3em] uppercase border border-cyan-sys text-cyan-sys hover:bg-cyan-sys hover:text-black px-3 py-1 disabled:opacity-50"
    >
      <RefreshCw size={11} className={busy ? 'animate-spin' : ''} />
      {busy ? 'refreshing...' : label}
      {lastUpdated && !busy && (
        <span className="text-[9px] text-[var(--txt-secondary)] normal-case tracking-normal ml-1">
          · {cstTime(lastUpdated)}
        </span>
      )}
    </button>
  );
}
